import React, { useState, useEffect, useContext } from "react";
import { useFilter, ContentView } from "hooks/filter";
import { Box, Grid, ToggleButton, ToggleButtonGroup, Select, MenuItem, Dialog, Tooltip } from "@mui/material";
import GridViewIcon from "@mui/icons-material/GridView";
import ViewListIcon from "@mui/icons-material/ViewList";
import { SortField } from '../../../types/qbank/searchSortField';
import { SortDirection } from '../../../types/qbank/searchSortDirection';
import { SearchState } from "../../../hooks/search";
import Transition from "components/Transition";
import FolderMoodBoardPanel from "../folders/FolderMoodBoardPanel";
import { Config } from "types/appConfigV2";
import { TotalHitsContext } from "../../../hooks/TotalHits";



export default function Toolbar(props: {
  config: Config
}) {
  const { contentView, setContentView, searchState, searchDispatch } = useFilter();
  const [selectedValue, setSelectedValue] = useState<string>('Id');
  const [isActive, setActive] = useState(false);
  const totalHitsContext = useContext(TotalHitsContext);



  const handleChange = (event: any) => {
    setSelectedValue(event.target.value as string);
    addSort(event.target.value);
  };

  function getSortFieldEnumKeyByValue(value: SortField): keyof typeof SortField {
    return (Object.keys(SortField) as Array<keyof typeof SortField>).find(
      key => SortField[key] === value
    )!;
  }

  const getActiveSortOption = (searchState: SearchState) => {
    const sortFields: any = searchState.search.sortFields;
    return (
      sortFields !== undefined ? getSortFieldEnumKeyByValue(sortFields[0].sortField) : ''
    );
  };

  useEffect(() => {
    const sortField = getActiveSortOption(searchState);
    if (sortField !== '') {
      setSelectedValue(sortField);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchState.search.sortFields]);

  function addSort(field: string) {

    searchDispatch({
      type: "ADD_SORT",
      payload: {
        sortField: SortField[field as keyof typeof SortField],
        sortDirection: SortDirection.DESC
      },
    });

  }
  function toggleFolderPanel() {
    setActive(!isActive);
  }

  function showFolderIcon() {
    if (props.config.folders || props.config.moodboard) {
      return true;
    }
    return false;
  }

  function getToolTipMessage() {
    if (props.config.folders && props.config.moodboard)
      return "Folders and Moodboards";

    if (props.config.folders)
      return "Folders";

    if (props.config.moodboard)
      return "Moodboards";

    return "";
  }
  return (
    <>
      <Box sx={{ flexGrow: 1 }}>
      <Grid
        container
        alignItems="center"
        justifyContent="space-between"
        spacing={2}
      >
          {showFolderIcon() && (
            <Tooltip title={getToolTipMessage()}>
            <Grid item>
              <div onClick={toggleFolderPanel}>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-square-mouse-pointer-icon lucide-square-mouse-pointer"><path d="M12.034 12.681a.498.498 0 0 1 .647-.647l9 3.5a.5.5 0 0 1-.033.943l-3.444 1.068a1 1 0 0 0-.66.66l-1.067 3.443a.5.5 0 0 1-.943.033z" /><path d="M21 11V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h6" /></svg>
                <span className="text-normal p-left-6">{totalHitsContext?.totalHits} assets</span>
              </div>
            </Grid>
            </Tooltip>
          )}
          {(!showFolderIcon() &&
            <Grid item>
              <span className="text-normal .p-left-6">{totalHitsContext?.totalHits} assets</span>
            </Grid>
          )}
        <Grid item>
          <Grid container justifyContent="flex-end">
              <Tooltip title="Sort by">
              <Select
              labelId="dropdown-label"
                variant="standard"
                disableUnderline
                sx={{
                  border: 'none',
                  backgroundColor: 'transparent',
                  '&::before, &::after': {
                    display: 'none',
                  },
                  '&:hover:not(.Mui-disabled):before': {
                    display: 'none',
                  },
                }}
              value={selectedValue}
                onChange={handleChange} >
                <MenuItem sx={{ fontSize: '14px', fontWeight: 400 }} value="Id">Latest</MenuItem>
                <MenuItem sx={{ fontSize: '14px', fontWeight: 400 }} value="Relevance">Relevance</MenuItem>
            </Select>
              </Tooltip>
            <ToggleButtonGroup
              color="primary"
              value={contentView}
              exclusive={true}
              size="small"
              onChange={(
                event: React.MouseEvent<HTMLElement>,
                view: ContentView
              ) => {
                if (view !== null) {
                  setContentView(view);
                }
              }}
            >
                <Tooltip title="Grid view">
              <ToggleButton
                size="small"
                disableRipple
                value="grid"
                aria-label="grid"
                  sx={{
                    border: 'none'
                  }}
              >
                <GridViewIcon />
              </ToggleButton>
                </Tooltip>
                <Tooltip title="List view">
              <ToggleButton
                size="small"
                disableRipple
                value="list"
                aria-label="list"
                  sx={{
                    border: 'none'
                  }}
              >
                <ViewListIcon />
              </ToggleButton>
                </Tooltip>
            </ToggleButtonGroup>
          </Grid>
        </Grid>
      </Grid>
    </Box>
      {showFolderIcon() && (
        <Dialog
          fullScreen
          open={isActive}
          onClose={() => setActive(false)}
          TransitionComponent={Transition}
          PaperProps={{
            sx: {
              overflow: 'hidden',
            },
          }}
        >
          <FolderMoodBoardPanel
            closePanel={() => setActive(false)}
            showFolders={props.config.folders}
            showMoodboards={props.config.moodboard}
          />
        </Dialog>
      )}
    </>
  );
}
